var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M43.3 60.7H1c-.5 0-1-.4-1-1s.4-1 1-1h42.3c.5 0 1 .4 1 1s-.5 1-1 1z",
    fill: "#868689",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3 60.7H7.1c-.5 0-1-.4-1-1V34.2c0-.5.4-1 1-1s1 .4 1 1v24.5h35.2c.5 0 1 .4 1 1s-.5 1-1 1z",
    fill: "#868689",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 36.2c-1.2 0-2.3-.4-3.2-1.3-.8-.8-1.3-2-1.3-3.2 0-1.1.5-2.2 1.2-3.1L24.1 5.7c3.2-3.2 8.3-3.2 11.5 0l9.8 9.8c.4.4.4 1 0 1.4s-1 .4-1.4 0l-9.8-9.8c-2.4-2.4-6.3-2.4-8.7 0L2.7 29.9c-.4.5-.7 1.2-.7 1.8 0 .5.1 1.2.7 1.8 1 1 2.7 1 3.7 0l22.8-22.8c.4-.4 1-.4 1.4 0l8.3 8.3c.4.4.4 1 0 1.4s-1 .4-1.4 0l-7.6-7.6L7.8 34.9c-.9.9-2.1 1.3-3.3 1.3zM32.9 60.7H18.7c-.5 0-1-.4-1-1V41.5c0-1.6 1.3-3 3-3H31c1.6 0 2.9 1.4 2.9 3v18.2c0 .5-.5 1-1 1zm-13.2-2h12.2V41.5c0-.6-.5-1-.9-1H20.7c-.6 0-1 .5-1 1zM49.5 60.6c-1.3 0-2.5-.7-3.2-1.8C42.8 53 34.9 39 34.9 33c0-8 6.5-14.5 14.5-14.5S64 25 64 33c0 4.2-3.8 12.8-11.2 25.8-.8 1.1-2 1.8-3.3 1.8zm-.1-40.1c-6.9 0-12.5 5.6-12.5 12.5 0 5.6 8.5 20.4 11.1 24.8.3.5.9.9 1.6.9s1.2-.3 1.6-.9C60.1 42.1 62 35.6 62 33c0-6.9-5.6-12.5-12.6-12.5z",
    fill: "#868689",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5 42.3c-5.1 0-9.3-4.2-9.3-9.3s4.2-9.3 9.3-9.3 9.3 4.2 9.3 9.3-4.2 9.3-9.3 9.3zm0-16.6c-4 0-7.3 3.3-7.3 7.3s3.3 7.3 7.3 7.3 7.3-3.3 7.3-7.3-3.3-7.3-7.3-7.3zM21.7 51.4c-.5 0-1-.4-1-1v-1.3c0-.5.4-1 1-1s1 .4 1 1v1.3c0 .5-.5 1-1 1z",
    fill: "#868689",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.d9d5baba7df0e54ebb3555f14f637508.svg";
export { ForwardRef as ReactComponent };